const AdminServicesStyle = {
  width: "100%",
};

const cardStyle = {
  mb: "1",
  overflow: "hidden",
  pl: "16px",
  position: "relative",
};

const labelStyle = {
  color: "mediumGray",
  fontFamily: "body",
  fontSize: "11px",
  fontWeight: "600",
  mb: "5px",
  mt: "7px",
};

const descriptionStyle = {
  fontFamily: "heading",
  fontSize: "13px",
  fontWeight: "600",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export { AdminServicesStyle, cardStyle, labelStyle, descriptionStyle };
